module.exports = __webpack_public_path__ + "img/testimonial-image-1.106aae0.png";